import axios from "axios";

export const SECTION_URL = "/Section";
export const STUDENT_URL = "/Student";
export const STUDENT_ABSENTEEISM_REPORT_URL = "/StudentAbsenteeismReport";

/** Mevcut Okula Ait Belli Bir Öğrenci Devamsızlık Raporunu Elde Eder */
export function getStudentAbsenteeismReport(queryParams) {
  return axios.post(`${STUDENT_ABSENTEEISM_REPORT_URL}/GetStudentAbsenteeismReport`, queryParams);
}

/** Mevcut Okula Ait Belli Bir Öğrenci Devamsızlık Raporunu Sayfalama Olmadan Elde Eder */
export function getAllStudentAbsenteeismReport(queryParams) {
  return axios.post(`${STUDENT_ABSENTEEISM_REPORT_URL}/GetAllStudentAbsenteeismReport`, queryParams);
}

/** Mevcut Okula Ait Şube Listesini Elde Eder */
export function getSections() {
  return axios.get(`${SECTION_URL}/GetSections`);
}

/** Mevcut Okula Ait Bir Dönemde Belli Bir Sınıftaki Öğrenci Listesini Elde Eder */
export function getStudents(term, sectionId) {
  return axios.get(`${STUDENT_URL}/GetStudentsInSection/${term}/${sectionId}`);
}